import { render, staticRenderFns } from "./AgreementList.html?vue&type=template&id=c6290f44&"
import script from "./AgreementList.component.js?vue&type=script&lang=js&"
export * from "./AgreementList.component.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./AgreementList.vue?vue&type=custom&index=0&blockType=div"
if (typeof block0 === 'function') block0(component)

export default component.exports